/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-arrow-callback */
import React, { useEffect, useMemo, useRef, useState, forwardRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import axios from '../../services/axios';
import useAutocompleteQueryGate from '../../hooks/useAutocompleteQueryGate';
import InputClearButton from '../MinorUtilities/InputClearButton/InputClearButton';
import { OptionButton } from '../../styles/ui/Button';

const Wrap = styled.div`
   position: relative;
`;

const Input = styled.input`
   width: 100%;
   padding-right: 48px;
`;

const InputBox = styled.div`
   position: relative;
`;

const Menu = styled.div`
   position: absolute;
   left: 0;
   right: 0;
   top: calc(100% + 6px);
   background: #fff;
   border: 1px solid rgba(0, 0, 0, 0.08);
   border-radius: 12px;
   overflow: hidden;
   z-index: 40;
   box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
   max-height: 320px;
   overflow-y: auto;
`;

const Row = styled(OptionButton)`
   font-size: 0.75rem;
   display: flex;
   align-items: center;
   gap: 10px;
`;

const InfoRow = styled.div`
   width: 100%;
   padding: 10px 12px;
   font-size: 0.75rem;
   color: #373737;
   opacity: 0.75;
`;

const Hint = styled.div`
   margin-top: 6px;
   font-size: 12px;
   opacity: 0.75;
`;

// ✅ ADAPTADO para novo formato da API
function toDisplayValue(product, displayMode) {
   if (!product) return '';
   // Novo formato: product.sku e product.name
   if (displayMode === 'sku-name')
      return `${product.sku} - ${product.name}`;
   return product.name;
}

function escapeRegExp(str) {
   return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function renderHighlighted(text, term) {
   const t = String(term || '').trim();
   if (!t) return text;

   const re = new RegExp(`(${escapeRegExp(t)})`, 'ig');
   const parts = String(text || '').split(re);

   return parts.map((p, i) =>
      i % 2 === 1 ? (
         <strong key={`${i}-${p}`}>{p}</strong>
      ) : (
         <span key={`${i}-${p}`}>{p}</span>
      )
   );
}

const ProductNameSearch = forwardRef(function ProductNameSearch(
   {
      value,
      onChange,
      onSelect,
      placeholder = 'Buscar produto por SKU ou nome...',
      minChars = 3,
      debounceMs = 250,
      limit = 15,

      // comportamento
      nameLike = true,
      skuExactDigits = 7,
      displayMode = 'name',
      showHint = false,

      // novo (pra evitar disabled "fixo")
      disabled = false,
   },
   ref
) {
   const [items, setItems] = useState([]);
   const [isOpen, setIsOpen] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [activeIndex, setActiveIndex] = useState(-1);
   const [isLocked, setIsLocked] = useState(false);

   const requestIdRef = useRef(0);
   const selectedRef = useRef(null);
   const inputRef = useRef(null);

   // permitir ref externo
   useEffect(() => {
      if (!ref) return;
      if (typeof ref === 'function') ref(inputRef.current);
      // eslint-disable-next-line no-param-reassign
      else ref.current = inputRef.current;
   }, [ref]);

   // unlock quando o valor limpou externamente
   useEffect(() => {
      if ((value ?? '') === '') {
         setIsLocked(false);
         selectedRef.current = null;
      }
   }, [value]);

   const debouncedQuery = useMemo(() => (value ?? '').trim(), [value]);

   const gate = useAutocompleteQueryGate({
      value,
      debouncedQuery,
      minChars,
      isLocked,
      requestIdRef,
   });

   const q = useMemo(() => String(gate.q || '').trim(), [gate.q]);
   const qIsNumeric = useMemo(() => /^\d+$/.test(q), [q]);

   const handleClear = () => {
      requestIdRef.current += 1;
      selectedRef.current = null;
      setIsLocked(true);
      setIsOpen(false);
      setItems([]);
      setActiveIndex(-1);
      onSelect?.(null);
      onChange?.('');
      setTimeout(() => inputRef.current?.focus(), 0);
   };

   const pick = (p) => {
      requestIdRef.current += 1;
      selectedRef.current = p;
      setIsLocked(true);
      setIsOpen(false);
      setItems([]);
      setActiveIndex(-1);

      const nextDisplay = toDisplayValue(p, displayMode);
      onChange?.(nextDisplay);
      onSelect?.(p);
   };

   const handleInputChange = (e) => {
      const next = e.target.value;

      if (isLocked) {
         selectedRef.current = null;
         setIsLocked(false);
         onSelect?.(null);
      }

      onChange?.(next);
   };

   useEffect(() => {
      if (disabled) {
         setIsLoading(false);
         setIsOpen(false);
         setItems([]);
         setActiveIndex(-1);
         return;
      }

      if (gate.shouldClose) {
         setIsLoading(false);
         setIsOpen(false);
         setItems([]);
         setActiveIndex(-1);
         return;
      }

      const myId = ++requestIdRef.current;

      setIsLoading(true);
      setIsOpen(true);
      setItems([]);
      setActiveIndex(-1);

      const t = setTimeout(async () => {
         try {
            // ✅ NOVO FORMATO DA API
            const resp = await axios.get('/products/search-name', {
               params: { q, limit },
            });

            if (myId !== requestIdRef.current) return;

            // ✅ Acessa através do envelope
            const apiData = resp.data;

            // ✅ Suporta AMBOS os formatos (transição suave)
            let list = [];
            if (apiData.status === 'success' && apiData.data?.products) {
               // Novo formato (com envelope)
               list = apiData.data.products;
            } else if (Array.isArray(apiData)) {
               // Formato antigo (array direto)
               list = apiData;
            }

            // auto-pick no modo restrito
            if (!nameLike && list.length) {
               if (qIsNumeric && q.length === skuExactDigits) {
                  // ✅ Usa product.sku (novo) com fallback para prod_sku (antigo)
                  const exactSku = list.find((p) => String(p.sku ?? p.prod_sku) === q);
                  if (exactSku) {
                     pick(exactSku);
                     setIsLoading(false);
                     return;
                  }
               }

               if (!qIsNumeric) {
                  const qLower = q.toLowerCase();
                  // ✅ Usa product.name (novo) com fallback para prod_name (antigo)
                  const exactNames = list.filter(
                     (p) => String(p.name ?? p.prod_name ?? '').toLowerCase() === qLower
                  );
                  if (exactNames.length === 1) {
                     pick(exactNames[0]);
                     setIsLoading(false);
                     return;
                  }
               }
            }

            setItems(list);
            setIsOpen(true);
            setActiveIndex(-1);
         } catch (err) {
            if (myId !== requestIdRef.current) return;
            setItems([]);
            setIsOpen(false);
            setActiveIndex(-1);
         } finally {
            if (myId === requestIdRef.current) setIsLoading(false);
         }
      }, debounceMs);

      // eslint-disable-next-line consistent-return
      return () => clearTimeout(t);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [
      q,
      debounceMs,
      limit,
      nameLike,
      qIsNumeric,
      skuExactDigits,
      disabled,
      gate.shouldClose,
   ]);

   const handleKeyDown = (e) => {
      if (!isOpen || !items.length) return;

      if (e.key === 'ArrowDown') {
         e.preventDefault();
         setActiveIndex((i) => Math.min(i + 1, items.length - 1));
      }

      if (e.key === 'ArrowUp') {
         e.preventDefault();
         setActiveIndex((i) => Math.max(i - 1, 0));
      }

      if (e.key === 'Enter') {
         e.preventDefault();
         if (activeIndex >= 0 && items[activeIndex]) pick(items[activeIndex]);
      }

      if (e.key === 'Escape') setIsOpen(false);
   };

   const handleFocus = () => {
      if (!isLocked && (items.length || isLoading)) setIsOpen(true);
   };

   const handleBlur = () => {
      setTimeout(() => {
         setIsOpen(false);

         if (nameLike) return;
         if (isLocked) return;
         if (selectedRef.current) return;

         const qNow = (value ?? '').trim();
         const qNowDigits = /^\d+$/.test(qNow);

         if (qNowDigits && qNow.length === skuExactDigits) return;
         if (qNow) handleClear();
      }, 120);
   };

   const showClear = !disabled && (value ?? '') !== '';

   return (
      <Wrap>
         <InputBox>
            <Input
               ref={inputRef}
               value={value ?? ''}
               placeholder={placeholder}
               onChange={handleInputChange}
               onKeyDown={handleKeyDown}
               onFocus={handleFocus}
               onBlur={handleBlur}
               disabled={disabled}
               autoComplete="off"
            />

            <InputClearButton
               visible={showClear}
               side="right"
               hoverText="Limpar"
               onClear={handleClear}
               disabled={disabled}
            />

            {isOpen && (
               <Menu>
                  {isLoading && <InfoRow>Carregando…</InfoRow>}

                  {!isLoading && items.length === 0 && q && (
                     <InfoRow>Nenhum produto encontrado.</InfoRow>
                  )}

                  {!isLoading &&
                     items.map((p, idx) => {
                        // ✅ Suporta AMBOS os formatos com fallback
                        const sku = p.sku ?? p.prod_sku;
                        const name = p.name ?? p.prod_name;

                        return (
                           <Row
                              key={`${p.id ?? idx}`}
                              type="button"
                              $active={idx === activeIndex}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => pick(p)}
                           >
                              <span>
                                 {qIsNumeric
                                    ? renderHighlighted(String(sku), q)
                                    : sku}{' '}
                                 -
                                 {qIsNumeric
                                    ? name
                                    : renderHighlighted(String(name || ''), q)}
                              </span>
                           </Row>
                        );
                     })}
               </Menu>
            )}
         </InputBox>

         {showHint && (
            <Hint>
               {nameLike
                  ? 'Digite parte do SKU ou do nome e selecione quando quiser.'
                  : `Selecione um item da lista (ou digite um SKU com ${skuExactDigits} dígitos).`}
            </Hint>
         )}
      </Wrap>
   );
});

ProductNameSearch.propTypes = {
   value: PropTypes.string,
   onChange: PropTypes.func,
   onSelect: PropTypes.func,
   placeholder: PropTypes.string,
   minChars: PropTypes.number,
   debounceMs: PropTypes.number,
   limit: PropTypes.number,
   nameLike: PropTypes.bool,
   skuExactDigits: PropTypes.number,
   displayMode: PropTypes.oneOf(['name', 'sku-name']),
   showHint: PropTypes.bool,
   disabled: PropTypes.bool,
};

export default ProductNameSearch;
